import { ETab, OPEN_TAB, SET_VISIBLE, RESET, SET_HEADER_VISIBLE } from 'store/sidebar/types';

export function openTab(tab: ETab) {
  return {
    type: OPEN_TAB,
    tab,
  };
}

export function resetSidebar() {
  return { type: RESET };
}

export function setSidebarVisibility(visible: boolean) {
  return {
    type: SET_VISIBLE,
    visible,
  };
}

export function setSidebarHeaderVisibility(displayNavHeader: boolean) {
  return {
    type: SET_HEADER_VISIBLE,
    displayNavHeader,
  };
}
